import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";

const fetchByTrainerId = (trainerId: number): AxiosPromise<TrainerTopicApi[]> => {
  return api.get<TrainerTopicApi[]>(endpoints.TRAINER_TOPICS.GET_BY_TRAINERID(trainerId));
};

export const trainerTopicsApi = {
  fetchByTrainerId,
};

export interface TrainerTopicApi {
  id: number;
  title: string;
  description: string;
  time?: number;
  type?: number;
  price?: number;
  priceType?: number;
}
